<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>
           <el-form-item label="状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option v-for="item in pkgStateOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品名称：">
                <el-input v-model.trim="searchForm.name" clearable></el-input>
            </el-form-item>
             <el-form-item label="运营商：">
                <el-input v-model.trim="searchForm.supplierName" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="warning" icon="el-icon-search" @click="getPkgListPageHandle" >搜索查询</el-button>
                <el-button type="primary"  icon="el-icon-edit"  @click="showAddPkg">新增商品</el-button>
                <!-- <el-button  type="success"  @click="showEditPkg11">我的微小店推广</el-button> -->
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >     
            <el-table-column type="index" label="序号" align="center"></el-table-column>  
            <el-table-column label="商品名称" width="350px">
                <template slot-scope="scope">
                    <el-row>
                        <el-col :span="8">
                            <img :src="getImgUrl() +  scope.row.titleImg" width="60" height="60" class="head_pic"/>
                        </el-col>
                        <el-col :span="16">
                            <div style="color:#409EFF;font-size:14px;cursor: pointer; white-space: normal;word-break: break-all; overflow: hidden;" @click="ditailsHeadle(scope.row)">{{scope.row.name}}</div>
                            <div style="color:#FF0024;line-height: 18px;height: 24px;">
                                <span style="border:1px solid #FF0024;padding: 2px 8px;border-radius: 3px;" v-show="scope.row.shopInfo">{{scope.row.shopInfo}}</span>
                            </div>
                            发布时间：{{scope.row.createTime}}
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>    
            <el-table-column prop="yongjingInfo" label="佣金额度说明"  align="center">
                  <template slot-scope="scope">
                      <div style=" white-space: normal;word-break: break-all; overflow: hidden;">{{scope.row.yongjingInfo}}</div>
                  </template>
            </el-table-column>
             <el-table-column  align="center"  label="商品类型">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.pkgType==10" class="item" effect="dark" :content="scope.row.agentPriceParent+'% 消费金额比例'">
                        <p style="color:#409EFF"> {{scope.row.pkgTypeName}}</p>
                    </el-tooltip>
                  <el-tooltip v-else class="item" effect="dark" :content="'立即佣金 '+scope.row.agentPriceRmb +'/元'">
                        <p style="color:teal"> {{scope.row.pkgTypeName}}</p>
                    </el-tooltip>
                   
                </template>
            </el-table-column> 
           
            <el-table-column prop="stateName" label="上下架"  align="center"></el-table-column>
             <el-table-column prop="supplierName" label="运营商"  align="center"></el-table-column>
            <el-table-column label="操作" width="280px">
                <template v-slot="scope">
                    <el-button type="success" plain size="small" @click="showEditPkg(scope.row)" >编辑</el-button>
                    <el-button type="primary" plain  size="small" @click="showEditPkg1(scope.row)" >推广链接</el-button>
                      <el-button  type="danger" icon="el-icon-delete" @click="deleteShop(scope.row.id)" >删除</el-button>
                </template>             
            </el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    
        <el-dialog :append-to-body="true" class="formDialog"  :title="title" :visible.sync="addPkgVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditPkgForm" :model="addOrEditPkgForm" label-width="120px">                
                <el-form-item label="商品名称:" prop="name">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.name" placeholder="必选" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                  <el-form-item label="商品展示图(建议像素512*512)：">
                    <input  type="file" ref="file1" placeholder="必选">
                    <div v-if="!existBackImg">商品图：</div>
                            <img v-else :src="getImgUrl() +  addOrEditPkgForm.titleImg" alt="" width="150" height="150">  
                </el-form-item>
                  <el-form-item label="商品介绍图(建议像素1080*450)：">
                    <input  type="file" ref="file2" placeholder="必选">
                    <div v-if="!existBackImg">介绍图：</div>
                            <img v-else :src="getImgUrl() +  addOrEditPkgForm.infoImg" alt="" width="150" height="150">  
                </el-form-item>
                 
                <el-form-item label="产品特点或要求:" prop="shopInfo">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.shopInfo"  placeholder="必选" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="佣金说明:" prop="yongjingInfo">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.yongjingInfo" placeholder="必选"    type="textarea"
                    :rows="2" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                  <el-form-item label="上下架状态：" prop="state">
                    <el-radio-group v-model="addOrEditPkgForm.state">
                        <el-radio label="0">上架</el-radio>
                        <el-radio label="1">下架</el-radio>
                    </el-radio-group>
                </el-form-item>

                 <el-form-item label="推广页类型：" prop="htmlType">
                    <el-radio-group v-model="addOrEditPkgForm.htmlType">
                        <el-radio label="2">普通页面</el-radio>
                        <el-radio label="3">选号页面</el-radio>
                        <el-radio label="17">身份证上传页面</el-radio>
                    </el-radio-group>
                </el-form-item>

                 <el-form-item label="结算类型：" prop="pkgType">
                    <el-radio-group v-model="addOrEditPkgForm.pkgType">
                        <el-radio label="10">月结</el-radio>
                        <el-radio label="11">一次性结清</el-radio>
                    </el-radio-group>
                </el-form-item>
                 <p v-if="!addFlag" style="color:red">如果降低了商品的利润，代理商销售列表的此商品 会全部删除，需要代理商重新加入。后面的所有订单结算 则按照此最新的分润</p>
                <el-form-item label="一次性金额:" prop="agentPriceRmb" v-if="addOrEditPkgForm.pkgType==11">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.agentPriceRmb" placeholder="必选" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                <el-form-item label="月结佣金比列:" prop="agentPriceParent" v-else>
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.agentPriceParent" placeholder="必选" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                  <el-form-item label="禁区:" prop="warnInfos">
                      <p style="color:red">如果仅是某个省可领取 则填 XX省仅限领取</p>
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.warnInfos" placeholder="多个禁区请以中文，号隔开 可以精确到市县。" clearable></el-input>
                    </el-col>                    
                </el-form-item>




                <el-form-item label="运营商:" prop="supplierName">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.supplierName" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="上游套餐名称:" prop="supplierShopName">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.supplierShopName" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                     <el-form-item label="账号:" prop="account">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.account" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                     <el-form-item label="密码:" prop="pwd">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.pwd" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                  <el-form-item label="密钥:" prop="pwdkey">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.pwdkey" clearable></el-input>
                    </el-col>                    
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
            </div>            
        </el-dialog>


        <el-dialog :append-to-body="true" class="formDialog"  title="详情" :visible.sync="detailsShow" width="600px" @close="detailsShowChange" :close-on-click-modal="false">
            <el-form ref="addOrEditPkgForm" :model="addOrEditPkgForm" label-width="120px">  
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="商品名称:">{{addOrEditPkgForm.name}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="产品特点或要求:">{{addOrEditPkgForm.shopInfo}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="上下架状态:">{{addOrEditPkgForm.state ==='1'?'下架' :addOrEditPkgForm.state ==='0'?'上架':''}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="推广页类型:">{{addOrEditPkgForm.htmlType ==='2'?'普通页面' :addOrEditPkgForm.htmlType ==='3'?'选号页面':'--'}}</el-form-item>
                    </el-col>
                     <el-col :span="12">
                        <el-form-item label="结算类型:">{{addOrEditPkgForm.pkgType ==='10'?'月结' :addOrEditPkgForm.pkgType ==='11'?'一次性结清':'--'}}</el-form-item>
                    </el-col>
                    <el-col :span="12"  v-if="addOrEditPkgForm.pkgType==11">
                        <el-form-item label="一次性金额:">{{addOrEditPkgForm.agentPriceRmb}}</el-form-item>
                    </el-col>
                    <el-col :span="12"  v-else>
                        <el-form-item label="月结佣金比列:">{{addOrEditPkgForm.agentPriceParent}}</el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="运营商:">{{addOrEditPkgForm.supplierName}}</el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="上游套餐名称:">{{addOrEditPkgForm.supplierShopName}}</el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="账号:">{{addOrEditPkgForm.account}}</el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="密码:">{{addOrEditPkgForm.pwd}}</el-form-item>
                    </el-col>
                     <el-col :span="24">
                        <el-form-item label="佣金说明:">{{addOrEditPkgForm.yongjingInfo}}</el-form-item>
                    </el-col>
                     <el-col :span="24">
                        <el-form-item label="禁区:">{{addOrEditPkgForm.warnInfos}}</el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="商品图:">
                            <el-image  v-if="addOrEditPkgForm.titleImg" style="width: 150px; height: 150px" :src="getImgUrl() +  addOrEditPkgForm.titleImg"  :preview-src-list="[getImgUrl() +  addOrEditPkgForm.titleImg]" />
                            <span v-else>暂无商品图</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="介绍图：:">
                            <el-image  v-if="addOrEditPkgForm.infoImg" style="width: 150px; height: 150px" :src="getImgUrl() +  addOrEditPkgForm.infoImg"  :preview-src-list="[getImgUrl() +  addOrEditPkgForm.infoImg]" />
                            <span v-else>暂无商品图</span>
                        </el-form-item>
                    </el-col>
                </el-row> 
            </el-form>             
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailsShowChange">取 消</el-button>
            </div>            
        </el-dialog>


        <el-dialog :append-to-body="true"  title="推广链接" :visible.sync="shareImgs" width="700px" @close="cancel" :close-on-click-modal="false">
            <div style="text-align: center; padding: 10px 0; color: #F56C6C;">注：请保存以下二维码进行推广商品，商品推广后 可在客服管理->申请列表里面查询</div>
            <div style="text-align: center; width:100%;">               
                <img  :src="getImgUrl() +  addOrEditPkgForm.shareImg" alt="" width="300px" height="300px" style="margin: 0 auto;">  
            </div>
            <div style="text-align: center; padding: 10px 0; color: #F56C6C;">推广链接  {{urls}}</div>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="copy()" class="copy_url" :data-clipboard-text="urls">复制链接</el-button>
                <el-button type="danger" @click="openLink()">打开链接</el-button>
            </div>            
        </el-dialog>
    </div>
</template>
<script>
import {getPkgListPage, addPkg, updatePkg, getPkgDetail, changePkgState, adminPkgSort} from '@/api/package.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
    data(){     
        return {
            shareImgs:false,
            frontImgUrl:'',
            existBackImg:false,
            searchForm: {
                supplierName: '',
                state: '',
                name: '',
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },            
            pkgTypeOption: [],
            pkgStateOption: [
                {'code':0,'description':'上架'},
                {'code':1,'description':'下架'}
            ],
            pkgStatesOption: [
                {'code':0,'description':'上架'},
                {'code':1,'description':'下架'}
            ],
            agentStateOption: [
                {'code':1,'description':'允许'},
                {'code':2,'description':'不允许'}
            ],
            supplierOption: [],
            addOrEditPkgForm: {
                titleImg:'',
                warnInfos:'',
                infoImg:'',
                agentPriceRmb:'',
                shopImgss:'',
                shopHeadImgs:'',
                state:'',
                name:'',
                account:'',
                pwd: '',
                supplierName: '',
                pwdkey:'',
                supplierShopName:'',
                htmlType:'',
                yongjingInfo:'',
                shopInfo:'',
                pkgType:'',
                agentPrice:'',
                agentPriceParent:''
                         
            },
            unit: 'G',
            currentId: '',
            addFlag: null,
            addPkgVisibale: false,
            pkgGroup: [],
            myPkgGroup: [],
            title: '',
            message:'',
            urls:'',
            detailsShow:false,
        }
    },
    methods: {

        deleteShop(id){
            var data={
                id:id
            }
         this.$confirm('删除后，代理商销售中心的此商品也会删除，且后面新产生的订单不会再进行核算佣金。 确定要删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest('haoka/share/delete', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                }
            })
            }).catch(()=>{})


             

        },
        cancel(){
            this.shareImgs=false;
            this.addPkgVisibale = false;    
            this.$refs.addOrEditPkgForm.resetFields();  
        },
        detailsShowChange(){
            this.detailsShow=false
        },
        //直接打开链接
        openLink(){
            window.open(this.urls)
        },
        //复制功能
        copy() {
            var clipboard = new Clipboard('.copy_url')
            clipboard.on('success', e => {
              this.$message.success('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        //同步上游套餐
        updateUpPkg(){
            common.sysRequest('pkg/update/up/pkg', null, 'get').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        numberHandle(e){          
            var reg = /^\d+(\.\d{1,2})?/;
            if(reg.exec(e.target.value)) {
                e.target.value = reg.exec(e.target.value)[0];
            }                  
        },
        getPkgListPageHandle($event){   
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                 common.sysRequest('haoka/share/info', data, 'post').then(res => {
                if(res.data.code == 200){
                     common.listCallback(this, res, 'tbpg'); 
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },   
        showAddPkg(){
            this.addPkgVisibale = true;
            this.addFlag = true;
            this.title = '新增商品';
        },
        showEditPkg1(row){
            var data = {
                id: row.id
            }
            common.sysRequest('haoka/share/urls', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.addOrEditPkgForm.shareImg=res.data.data.img;
                    this.shareImgs=true;
                    this.urls=res.data.data.url;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        showEditPkg11(row){
            var data = {
                id: row.id
            }
            common.sysRequest('haoka/share/addree/urls', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.addOrEditPkgForm.shareImg=res.data.data.img;
                    this.shareImgs=true;
                    this.urls=res.data.data.url;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        // 点击名称查看详情
        ditailsHeadle(row){
            var data = {
                id: row.id
            }
            this.detailsShow=true;
            common.sysRequest("haoka/share/infos", data, 'post').then(res=>{
                var result = res.data.data;
                for(var key in this.addOrEditPkgForm){
                    this.addOrEditPkgForm[key] = result[key]
                    this.addOrEditPkgForm.state = String(result.state)
                    this.addOrEditPkgForm.htmlType = String(result.htmlType)
                    this.addOrEditPkgForm.pkgType = String(result.pkgType)
                }        
            }).catch(err=> console.error(err));
        },
        showEditPkg(row){
            this.frontImgUrl=true;
            this.addPkgVisibale = true;
            this.addFlag = false;
            this.title = '修改商品';  
            this.currentId = row.id;   
            var data = {
                id: row.id
            }
            this.existBackImg=true;
            common.sysRequest("haoka/share/infos", data, 'post').then(res=>{
                var result = res.data.data;
                for(var key in this.addOrEditPkgForm){
                    this.addOrEditPkgForm[key] = result[key]
                    this.addOrEditPkgForm.state = String(result.state)
                    this.addOrEditPkgForm.htmlType = String(result.htmlType)
                    this.addOrEditPkgForm.pkgType = String(result.pkgType)
                }        
            }).catch(err=> console.error(err));
                         
        },
        addOrEidtPkgHandle(){
            this.$refs.addOrEditPkgForm.validate(valid => {
                if(valid) {
                    let fd = new FormData();
                    this.addOrEditPkgForm.id=this.currentId;
                    if(this.addOrEditPkgForm.agentPriceParent==''|| this.addOrEditPkgForm.agentPriceParent==null){
                        this.addOrEditPkgForm.agentPriceParent='0';
                    }
                    Object.keys(this.addOrEditPkgForm).forEach((key) => {
                        fd.append(key, this.addOrEditPkgForm[key]);
                    })
          
                    if(this.addFlag == true){
                        fd.append('title',this.$refs.file1.files[0]);
                        fd.append('info',this.$refs.file2.files[0]);
                        common.sysRequest("haoka/insert/share", fd, 'post').then(res=>{
                            if(res.data.code == 200){
                                  this.$refs.file1.value='';
                                 this.$refs.file2.value='';
                                this.$message.success(res.data.message);
                                callback(res);
                                for (let val in this.addOrEditPkgForm) {
                                    this.addOrEditPkgForm[val] = "";
                                }
                            }else{
                                this.$message.error(res.data.message);
                            }
                        }).catch(err=> console.error(err));
                    }else{
                        if(this.$refs.file1.files[0]!='undefined'&&this.$refs.file1.files[0]!=''&&this.$refs.file1.files[0]!=null){
                            fd.append('title',this.$refs.file1.files[0]);
                            fd.append('info',this.$refs.file2.files[0]);
                        }
                        common.sysRequest("haoka/update/share", fd, 'post').then(res=>{
                            if(res.data.code == 200){
                                this.$refs.file1.value='';
                                 this.$refs.file2.value='';
                                this.$message.success(res.data.message);
                                callback(res);
                            }else{
                                this.$message.error(res.data.message);
                            }
                                    
                        }).catch(err=> console.error(err));             
                    }                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getPkgListPageHandle();
                        _this.addPkgVisibale = false;
                        
                    }else{                        
                        _this.$message.error(res.data.message)
                    }                     
                }
            })             
        },
      
        updateSortNo(row){
            //修改排序号
            var data = {
                id: row.id,
                sort: row.sort
            }
            common.sysRequest('app/pc/update/store/sort', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                }
            })
            
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getPkgListPageHandle();
        },
        //选择套餐组
        whenChoosePagGroup(val){
            for(let index in this.pkgGroup){
                if(this.pkgGroup[index].id == val){
                    this.addOrEditPkgForm.supplierType = this.pkgGroup[index].supplierType;
                }
            }
            if(this.addOrEditPkgForm.supplierType == 66){
                common.sysRequest('external/pkg/list', null, 'get').then(res => {
                    if(res.data.code == 200){
                        this.myPkgGroup = res.data.data.map.pkgs;
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            
        }

    },
    created () {
        this.getPkgListPageHandle();
        
    }  
}
</script>
<style lang="less" scoped>
.input-with-select .el-input {
    width: 60px;
}
.formDialog{
    ::v-deep .el-dialog{
        .el-dialog__body{
            height:500px;
            overflow: auto;
        }
    }
}
</style>

